import Vue from 'vue';

import 'es6-promise/auto';
import 'vue-breakpoints';
import 'promise-queue';
import 'clipboard';

import 'prismjs';
import 'prismjs/components/prism-jsx';
import 'prismjs/components/prism-csharp';
import 'prismjs/components/prism-java';
import 'prismjs/components/prism-php';
import 'prismjs/components/prism-markup-templating';
import 'prismjs/components/prism-ruby';
import 'prismjs/components/prism-bash';
import 'prismjs/components/prism-visual-basic';
import 'prismjs/components/prism-python';
import 'prismjs/components/prism-handlebars';

import 'prismjs/plugins/line-numbers/prism-line-numbers.min';
import 'prismjs/plugins/line-numbers/prism-line-numbers.css';
import 'prismjs/plugins/normalize-whitespace/prism-normalize-whitespace';
import 'prismjs/themes/prism-okaidia.css';

import './util/meta.js';
import './components/playground/languages.js';
import './components/core/BaseModalSelect.vue';
import './components/core/BaseDropdown.vue';
import './components/core/Slider.vue';
import './components/forms/elements/Country.vue';

import createApp from './app';
import ProgressBar from './components/ProgressBar.vue';

import tracker from './util/tracker';

// global progress bar
Vue.prototype.$bar = new Vue(ProgressBar).$mount();
const bar = Vue.prototype.$bar;
document.body.appendChild(bar.$el);

// a global mixin that calls `asyncData` when a route component's params change
Vue.mixin({
   beforeRouteUpdate(to, from, next) {
      const { asyncData } = this.$options;
      if (asyncData) {
         asyncData({
            store: this.$store,
            route: to,
         })
            .then(next)
            .catch(next);
      } else {
         next();
      }
   },
});

const { app, router, store } = createApp();

// prime the store with server-initialized state.
// the state is determined during SSR and inlined in the page markup.
if (window.__INITIAL_STATE__) {
   store.replaceState(window.__INITIAL_STATE__);
}

Vue.prototype.$tracker = tracker(store);

// wait until router has resolved all async before hooks
// and async components...
router.onReady(() => {
   // Add router hook for handling asyncData.
   // Doing it after initial route is resolved so that we don't double-fetch
   // the data that we already have. Using router.beforeResolve() so that all
   // async components are resolved.
   // eslint-disable-next-line consistent-return
   router.beforeResolve((to, from, next) => {
      const matched = router.getMatchedComponents(to);
      const prevMatched = router.getMatchedComponents(from);
      let diffed = false;
      const activated = matched.filter((c, i) => {
         if (diffed) {
            return diffed;
         }
         diffed = prevMatched[i] !== c;
         return diffed;
      });
      const asyncDataHooks = activated.map(c => c.asyncData).filter(_ => _);
      if (!asyncDataHooks.length) {
         return next();
      }

      bar.start();

      // Remove an Existing Chart from a Page before navigate to next page
      Object.keys(FusionCharts.items).forEach(key => {
         const chartObj = FusionCharts.items[key];
         if (typeof chartObj !== 'undefined') chartObj.dispose();
      });

      Promise.all(asyncDataHooks.map(hook => hook({ store, route: to })))
         .then(() => {
            bar.finish();
            next();
         })
         .catch(next);
   });

   router.afterEach(to => {
      try {
         if (window && window.ga) {
            setTimeout(() => {
               window.ga('gtm2.send', 'pageview', {
                  page: to.fullPath,
                  title: document.title,
               });
            }, 1000);
         }
      } catch (error) {
         console.error('GA not working');
      }
   });

   // actually mount to DOM
   app.$mount('#app');
});

// service worker
if (window.location.protocol === 'https:' && navigator.serviceWorker) {
   navigator.serviceWorker.register('/sw.js');
}
